<template>
  <div class="home">
    <div class="top">
      <!--      <van-image-->
      <!--        round-->
      <!--        width="6rem"-->
      <!--        height="6rem"-->
      <!--        src="https://res.hc-cdn.com/cnpm-common-resource/2.0.2/base/header/components/images/logo.png"-->
      <!--      />-->
      <img style="width: 150px" src="http://cdn.sport.hhstu.xyz/titile2.jpg" alt="">
    </div>
    <van-row>
      <van-col span="2"></van-col>
      <van-col span="20">
        <van-form @submit="onSubmit">
          <van-field
            right-icon="friends-o"
            clearable
            v-model="stuname"
            name="a"
            label="姓名"
            placeholder="姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <van-field
            right-icon="star-o"
            clearable
            v-model="stunum"
            type="password"
            name="b"
            label="学号"
            placeholder="学号"
            :rules="[{ required: true, message: '请填写学号' }]"
          />
          <div style="margin: 16px;">
            <van-button round block type="info" native-type="submit">
              登录
            </van-button>
          </div>
        </van-form>
      </van-col>
      <van-col span="2"></van-col>
    </van-row>
  </div>
</template>

<script>
import Vue from 'vue';
import {Button, Field, Form, Col, Row, Image} from 'vant';
import {StuLogin} from "@/network/login";

Vue.use(Image);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(Col);
Vue.use(Row);
export default {
  name: "Student",
  data() {
    return {
      stuname: '',
      stunum: '',
    }
  },
  created() {
    if (document.domain.indexOf("fzxy") != -1) {
      StuLogin(this.$route.query.name, this.$route.query.id, "fzxy").then(res => {
        if (res.islogin) {
          this.$store.commit('logined');
          this.$store.commit('inituser', res);
          this.$cookies.set("islogin", true, '6m');
          this.$cookies.set("user", res.user, '6m');
          this.$cookies.set("info", res.info, '6m');
          this.$router.replace("/home");
        }
      });
    }
  },
  methods: {
    onSubmit(values) {
      this.$bus.$emit('UserLogin', values);
    },
  },
  components: {}

}
</script>

<style scoped>
.home {
  text-align: center;
}

.top {
  padding: 30px;
}

</style>
